// Note: Mask Component separate from HOC mask component, this one you can simply add as a component for better control.

// @flow
// Libs
import React from 'react'
import _isEqual from 'lodash/isEqual'

// Components
import MessageBox from './Request'

// Styles
import {
  container,
  maskedStyle,
} from './../styles'

// Types
type Props = {
  visible: boolean,
  messages: ?Object,
}

type State = {
  show: boolean,
}

export default class MaskComponent extends React.Component {
  props: Props
  renderMessage: Function

  constructor (props: Props) {
    super(props)
    this.state = {
      show: false,
    }
    this.renderMessage = this.renderMessage.bind(this)
  }

  componentWillReceiveProps (nextProps: Props) {
    if (!_isEqual(this.props, nextProps)) {
      this.setState({show: nextProps.visible})
    }
  }

  shouldComponentUpdate (nextProps: Props, nextState: State) {
    return !_isEqual(this.props, nextProps) || !_isEqual(this.state, nextState)
  }

  renderMessage (): React.Element<any> {
    // NOTES
    // messages schema for Message infobox on top of overlay:
    // Object {
    //   request: { status: 'IN_PROGRESS' },
    //   name: 'map',
    // }
    const msg = this.props.messages
    return (
      <div data-test='_operationMessages' style={maskedStyle}>
        {msg && <MessageBox request={msg.request} name={msg.name} />}
      </div>
    )
  }

  render (): React.Element<any> {
    const containerStyle = {
      ...container,
      zIndex: 1000,
      display: 'block',
    }
    return (
      <div
        key='_operation'
        style={this.state.show ? containerStyle : {display: 'none'}}
      >
        {this.renderMessage()}
      </div>
    )
  }
}
